/**
 * 商品数据源配置及详情生成器
 * 1. 消除商品重复展示（所有商品互不重复）
 * 2. 支持根据 goodsId 查阅各个商品的专属详情
 * 3. 图片仅保留一张主图，移除多余小图
 * 4. 规格选项移除小图片，仅保留贴合商品的纯文字款式与价格
 * 5. 详情介绍若无图则留空，前端展示“暂无图片”
 */

// 外部商品列表（8 款互不重复的精选商品）
export const goodsList = [
  {
    goodsId: '1001',
    img: 'static/img/goodsList/item-show-1.jpg',
    price: 36.60,
    intro: 'SKSK 苹果7/7plus手机壳 iPhone 7 Plus保护套全包硬壳男女磨砂防摔 火影红',
    remarks: 6160,
    shopName: '元亨利配件专营店',
    sale: 9900
  },
  {
    goodsId: '1002',
    img: 'static/img/goodsList/item-show-2.jpg',
    price: 28.00,
    intro: '蒙奇奇 苹果6s手机壳磨砂防摔保护套 适用于iPhone6/6s/6sPlus 4.7英寸',
    remarks: 3000,
    shopName: 'monqiqi旗舰店',
    sale: 9600
  },
  {
    goodsId: '1003',
    img: 'static/img/goodsList/item-show-3.jpg',
    price: 15.00,
    intro: 'BIAZE 苹果6/6s手机壳 苹果iPhone6s 4.7英寸高透清爽系列保护套',
    remarks: 2800,
    shopName: 'BIAZE官方旗舰店',
    sale: 8900
  },
  {
    goodsId: '1004',
    img: 'static/img/goodsList/item-show-4.jpg',
    price: 29.90,
    intro: '慕臣 苹果6s手机壳全包防摔磨砂软保护套 经典商务黑 亲肤微砂手感',
    remarks: 9000,
    shopName: '歌乐力手配专营店',
    sale: 8600
  },
  {
    goodsId: '1005',
    img: 'static/img/goodsList/item-show-5.jpg',
    price: 19.90,
    intro: '品胜 苹果8/7高透气囊防摔手机壳 四角加厚防撞软硅胶全包保护套',
    remarks: 5420,
    shopName: '品胜数码官方旗舰店',
    sale: 8560
  },
  {
    goodsId: '1006',
    img: 'static/img/goodsList/item-show-6.jpg',
    price: 38.00,
    intro: '图拉斯 苹果XR/11极简超薄微砂硬壳 散热防指纹保护壳',
    remarks: 4820,
    shopName: '图拉斯自营旗舰店',
    sale: 8530
  },
  {
    goodsId: '1007',
    img: 'static/img/goodsList/item-show-7.jpg',
    price: 16.80,
    intro: '绿联 苹果全包镜头轻薄透明软壳 适用iPhone8/7/6s 镜头加高防刮花',
    remarks: 3660,
    shopName: '绿联数码官方专营店',
    sale: 8360
  },
  {
    goodsId: '1008',
    img: 'static/img/goodsList/item-show-8.jpg',
    price: 25.50,
    intro: '倍思 苹果电镀边框超薄透明防摔保护壳 裸机手感电镀金/银 适用iPhone系列',
    remarks: 4120,
    shopName: '倍思数码旗舰店',
    sale: 7560
  }
];

// 侧边栏广告精选（2 款独立商品）
export const asItems = [
  {
    goodsId: '2001',
    img: 'static/img/goodsList/item-as-img-1.jpg',
    price: 39.90,
    intro: 'SKSK 苹果7/7plus电镀防摔硬壳 商务轻奢微砂质感',
    num: 3140,
    remarks: 3140,
    shopName: 'SKSK数码专营店',
    sale: 9000
  },
  {
    goodsId: '2002',
    img: 'static/img/goodsList/item-as-img-2.jpg',
    price: 36.60,
    intro: '狮普 苹果7/7 Plus手机壳 电镀超薄全包防摔外壳',
    num: 6160,
    remarks: 6160,
    shopName: '狮普数码专营店',
    sale: 8900
  }
];

// 首页秒杀商品（5 款独立商品）
export const seckillGoods = [
  {
    goodsId: '3001',
    intro: '【赠小风扇】维他 柠檬茶250ml*32盒 礼品装 整箱',
    img: 'static/img/index/seckill/seckill-item1.jpg',
    price: 71.9,
    realPrice: 89.6,
    remarks: 24500,
    shopName: '维他饮料官方旗舰店',
    sale: 35000
  },
  {
    goodsId: '3002',
    intro: 'Kindle Paperwhite 全新升级版6英寸护眼非反光电子墨水',
    img: 'static/img/index/seckill/seckill-item2.jpg',
    price: 989.0,
    realPrice: 1299.0,
    remarks: 8930,
    shopName: '亚马逊电子自营店',
    sale: 12000
  },
  {
    goodsId: '3003',
    intro: '粮悦 大吃兄糯米锅巴 安徽特产锅巴糯米原味400g*2盒',
    img: 'static/img/index/seckill/seckill-item3.jpg',
    price: 21.8,
    realPrice: 49.0,
    remarks: 15300,
    shopName: '大吃兄零食旗舰店',
    sale: 28000
  },
  {
    goodsId: '3004',
    intro: '【京东超市】清风（APP）抽纸 原木纯品金装系列 3层120抽*24包',
    img: 'static/img/index/seckill/seckill-item4.jpg',
    price: 49.9,
    realPrice: 59.0,
    remarks: 42100,
    shopName: '清风纸业自营旗舰店',
    sale: 56000
  },
  {
    goodsId: '3005',
    intro: 'NIKE耐克 男子休闲鞋 AIR MAX 90 ESSENTIAL 气垫经典复古跑鞋',
    img: 'static/img/index/seckill/seckill-item5.jpg',
    price: 559.9,
    realPrice: 759.9,
    remarks: 7800,
    shopName: 'NIKE官方自营专区',
    sale: 9200
  }
];

// 购物车推荐商品
export const recommendGoods = [
  [
    {
      goodsId: '4001',
      img: 'static/img/otherBuy/1.jpg',
      intro: 'iPhone7/6s/8钢化膜苹果7Plus全屏全覆盖3D抗蓝光',
      price: 29.00,
      remarks: 6500,
      shopName: '邦克仕数码专营店',
      sale: 8200
    },
    {
      goodsId: '4002',
      img: 'static/img/otherBuy/2.jpg',
      intro: '苹果数据线 苹果iPhoneX/6s/7plus/8编织快充充电线',
      price: 36.00,
      remarks: 5200,
      shopName: '绿联数码官方专营店',
      sale: 7400
    },
    {
      goodsId: '4003',
      img: 'static/img/otherBuy/3.jpg',
      intro: '苹果8/7/6/6s钢化膜 iphone8/7/6s/6高清防爆钢化玻璃膜',
      price: 19.00,
      remarks: 4100,
      shopName: '倍思数码旗舰店',
      sale: 6900
    },
    {
      goodsId: '4004',
      img: 'static/img/otherBuy/4.jpg',
      intro: 'iPhone6s/7钢化膜苹果8 Plus手机膜抗蓝光护眼非全屏',
      price: 28.00,
      remarks: 3800,
      shopName: '闪魔旗舰店',
      sale: 5800
    }
  ],
  [
    {
      goodsId: '4005',
      img: 'static/img/otherBuy/5.jpg',
      intro: '苹果6s手机壳iPhone6s Plus保护壳防摔全包磨砂手感',
      price: 28.00,
      remarks: 4900,
      shopName: 'monqiqi旗舰店',
      sale: 6200
    },
    {
      goodsId: '4006',
      img: 'static/img/otherBuy/6.jpg',
      intro: 'iPhone7/8手机壳手机套防摔磨砂保护壳星空黑☆全包保护',
      price: 30.00,
      remarks: 7200,
      shopName: '元亨利配件专营店',
      sale: 9100
    },
    {
      goodsId: '4007',
      img: 'static/img/otherBuy/7.jpg',
      intro: '双弯头编织数据线 适用于苹果iPhone 6s/6plus/7plus/8/X',
      price: 18.00,
      remarks: 3100,
      shopName: '品胜数码官方旗舰店',
      sale: 4600
    },
    {
      goodsId: '4008',
      img: 'static/img/otherBuy/8.jpg',
      intro: 'iPhone8/7/6S/6钢化膜 苹果8/7/6s/6玻璃膜 手机高透全贴合',
      price: 15.00,
      remarks: 2900,
      shopName: 'BIAZE官方旗舰店',
      sale: 3900
    }
  ]
];

// 全部基础商品平铺表
const allBasicGoodsList = [
  ...goodsList,
  ...asItems,
  ...seckillGoods,
  ...recommendGoods[0],
  ...recommendGoods[1]
];

/**
 * 通用动态生成详情（无图片时留空，规格纯文字，绝无手机配件违和字段）
 */
export function buildMockDetailFromBasic (item) {
  const p = Number(item.price) || 29.9;
  const remarksCount = item.remarks || item.num || 3600;
  const img = item.img || '';

  // 规格套餐：纯文字，不带小图片，贴近常规电商规格
  const setMeal = [
    [
      { intro: '标准常规装', price: p },
      { intro: '精选升级款', price: Number((p * 1.15).toFixed(2)) },
      { intro: '超值双份装', price: Number((p * 1.85).toFixed(2)) }
    ],
    [
      { intro: '家庭分享特惠装', price: Number((p * 2.2).toFixed(2)) },
      { intro: '礼盒尊享定制装', price: Number((p * 2.6).toFixed(2)) }
    ]
  ];

  // 参数
  const param = [
    { title: '商品名称', content: item.intro || '精选优品' },
    { title: '商品编号', content: `NO.${item.goodsId || '886923'}` },
    { title: '店铺名称', content: item.shopName || '官方认证品牌店' },
    { title: '包装形式', content: '品牌正品原厂包装' },
    { title: '售后保障', content: '支持7天无理由退换货' },
    { title: '发货时效', content: '24小时内极速发货' }
  ];

  // 评价
  const remarks = {
    goodAnalyse: 98,
    remarksTags: ['正品保障', '品质优秀', '发货迅速', '卖家服务好', '还会回购'],
    remarksNumDetail: [
      Math.floor(remarksCount * 0.25),
      Math.floor(remarksCount * 0.65),
      Math.floor(remarksCount * 0.08),
      Math.floor(remarksCount * 0.02)
    ],
    detail: [
      {
        username: 'k****8',
        values: 5,
        content: `收到了，非常满意！跟商品描述一模一样，质量比预期的还要好很多。`,
        goods: '标准常规装',
        time: '2025-05-18 10:25'
      },
      {
        username: 'm****a',
        values: 5,
        content: `物流特别快，隔天就送到了。包装严实没有任何损坏，性价比极高！`,
        goods: '精选升级款',
        time: '2025-05-16 14:12'
      }
    ]
  };

  return {
    goodsId: item.goodsId,
    title: item.intro,
    price: p,
    goodsImg: img ? [img] : [], // 单张主图
    tags: ['品质严选', '满69减20', '正品行货', '顺丰速递'],
    discount: ['满99减10', '满199减25', '满299减40'],
    promotion: ['限时特卖', '多买优惠'],
    remarksNum: remarksCount,
    shopName: item.shopName || '官方旗舰店',
    setMeal: setMeal,
    hot: [
      { img: 'static/img/goodsList/item-show-1.jpg', price: 36.60, sale: 9900 },
      { img: 'static/img/goodsList/item-show-2.jpg', price: 28.00, sale: 9600 }
    ],
    goodsDetail: [], // 无专属宣传海报则留空，前端展示“暂无图片”
    param: param,
    remarks: remarks
  };
}

// 预定义各商品的专属详情数据
const detailedGoodsInfoMap = {
  // 1001: SKSK 苹果7/7plus手机壳 火影红
  '1001': {
    goodsId: '1001',
    title: 'SKSK 苹果7/7plus手机壳 iPhone 7 Plus保护套全包硬壳男女磨砂防摔 火影红',
    price: 36.60,
    goodsImg: ['static/img/goodsList/item-show-1.jpg'],
    tags: ['火影红限定款', '微砂防指纹', '四角全包防摔', '官方正品'],
    discount: ['满69减20', '满148减10', '满218减20'],
    promotion: ['火热促销', '第二件立减10元'],
    remarksNum: 6160,
    shopName: '元亨利配件专营店',
    setMeal: [
      [
        { intro: 'iPhone 7 (4.7英寸) - 火影红', price: 36.60 },
        { intro: 'iPhone 7 Plus (5.5英寸) - 火影红', price: 38.60 },
        { intro: 'iPhone 7 (4.7英寸) - 经典黑', price: 35.00 }
      ],
      [
        { intro: 'iPhone 7 Plus (5.5英寸) - 经典黑', price: 37.00 },
        { intro: 'iPhone 7 (4.7英寸) - 深邃蓝', price: 35.50 }
      ]
    ],
    hot: [
      { img: 'static/img/goodsList/item-show-2.jpg', price: 28.00, sale: 9600 },
      { img: 'static/img/goodsList/item-show-3.jpg', price: 15.00, sale: 8900 }
    ],
    goodsDetail: [], // 无对应图写暂无图片
    param: [
      { title: '商品名称', content: 'SKSK 苹果7/7plus火影红磨砂壳' },
      { title: '商品编号', content: 'NO.10017789' },
      { title: '店铺', content: '元亨利配件专营店' },
      { title: '材质', content: '进口环保PC硬壳' },
      { title: '适用机型', content: 'iPhone 7 / iPhone 7 Plus' }
    ],
    remarks: {
      goodAnalyse: 97,
      remarksTags: ['颜色纯正', '微砂手感棒', '严丝合缝', '孔位精准', '防指纹'],
      remarksNumDetail: [1800, 4100, 240, 20],
      detail: [
        {
          username: '红色**者',
          values: 5,
          content: '火影红真的太帅了！微砂手感很舒服，全包防摔很安心，孔位对得很准！',
          goods: 'iPhone 7 (4.7英寸) - 火影红',
          time: '2025-05-10 11:20'
        }
      ]
    }
  },

  // 1002: 蒙奇奇 苹果6s手机壳磨砂防摔
  '1002': {
    goodsId: '1002',
    title: '蒙奇奇 苹果6s手机壳磨砂防摔保护套 适用于iPhone6/6s/6sPlus 4.7英寸',
    price: 28.00,
    goodsImg: ['static/img/goodsList/item-show-2.jpg'],
    tags: ['正版授权', '手感细腻', '超薄透气', '满减包邮'],
    discount: ['满50减8', '满100减20'],
    promotion: ['限时立减', '多买优惠'],
    remarksNum: 3000,
    shopName: 'monqiqi旗舰店',
    setMeal: [
      [
        { intro: 'iPhone 6/6s (4.7英寸) - 磨砂黑', price: 28.00 },
        { intro: 'iPhone 6sPlus (5.5英寸) - 磨砂黑', price: 30.00 },
        { intro: 'iPhone 6/6s (4.7英寸) - 香槟金', price: 28.00 }
      ]
    ],
    hot: [
      { img: 'static/img/goodsList/item-show-1.jpg', price: 36.60, sale: 9900 }
    ],
    goodsDetail: [],
    param: [
      { title: '商品名称', content: '蒙奇奇磨砂防摔保护套' },
      { title: '商品编号', content: 'NO.10028821' },
      { title: '店铺', content: 'monqiqi旗舰店' },
      { title: '材质', content: '高分子磨砂PC' }
    ],
    remarks: {
      goodAnalyse: 96,
      remarksTags: ['手感极佳', '超薄舒适', '质量好'],
      remarksNumDetail: [800, 2050, 140, 10],
      detail: [
        {
          username: 'q****0',
          values: 5,
          content: '壳子做工很好，磨砂触感很棒，套在6s上很服帖！',
          goods: 'iPhone 6/6s (4.7英寸) - 磨砂黑',
          time: '2025-05-12 18:22'
        }
      ]
    }
  },

  // 1003: BIAZE 苹果6/6s手机壳 高透清爽系列
  '1003': {
    goodsId: '1003',
    title: 'BIAZE 苹果6/6s手机壳 苹果iPhone6s 4.7英寸高透清爽系列保护套',
    price: 15.00,
    goodsImg: ['static/img/goodsList/item-show-3.jpg'],
    tags: ['高透防发黄', '四边气囊', '裸机视感', '破损包赔'],
    discount: ['满30减5', '满50减10'],
    promotion: ['买一送一', '店铺满减'],
    remarksNum: 2800,
    shopName: 'BIAZE官方旗舰店',
    setMeal: [
      [
        { intro: '4.7英寸 - 纯净高透款', price: 15.00 },
        { intro: '5.5英寸 - 纯净高透款', price: 16.50 },
        { intro: '4.7英寸 - 透黑防指纹款', price: 16.00 }
      ]
    ],
    hot: [
      { img: 'static/img/goodsList/item-show-5.jpg', price: 19.90, sale: 8560 }
    ],
    goodsDetail: [],
    param: [
      { title: '商品名称', content: 'BIAZE高透气囊保护套' },
      { title: '店铺', content: 'BIAZE官方旗舰店' },
      { title: '材质', content: '进口高透软胶' }
    ],
    remarks: {
      goodAnalyse: 99,
      remarksTags: ['超清透亮', '不发黄', '性价比高'],
      remarksNumDetail: [700, 2010, 80, 10],
      detail: [
        {
          username: '透明**控',
          values: 5,
          content: '真正透亮如裸机，保护很到位，性价比极高！',
          goods: '4.7英寸 - 纯净高透款',
          time: '2025-05-14 09:15'
        }
      ]
    }
  },

  // 1004: 慕臣 苹果6s手机壳 经典商务黑
  '1004': {
    goodsId: '1004',
    title: '慕臣 苹果6s手机壳全包防摔磨砂软保护套 经典商务黑 亲肤微砂手感',
    price: 29.90,
    goodsImg: ['static/img/goodsList/item-show-4.jpg'],
    tags: ['商务简约', '防手汗', '全包软边', '独立按键'],
    discount: ['满60减10', '满120减25'],
    promotion: ['限时特惠', '官方正品'],
    remarksNum: 9000,
    shopName: '歌乐力手配专营店',
    setMeal: [
      [
        { intro: 'iPhone 6/6s - 曜石黑', price: 29.90 },
        { intro: 'iPhone 6sPlus - 曜石黑', price: 32.90 },
        { intro: 'iPhone 6/6s - 暗夜绿', price: 29.90 }
      ]
    ],
    hot: [
      { img: 'static/img/goodsList/item-show-6.jpg', price: 38.00, sale: 8530 }
    ],
    goodsDetail: [],
    param: [
      { title: '商品名称', content: '慕臣商务磨砂软壳' },
      { title: '店铺', content: '歌乐力手配专营店' },
      { title: '材质', content: '液态微砂软硅胶' }
    ],
    remarks: {
      goodAnalyse: 98,
      remarksTags: ['手感顺滑', '耐脏易清洗', '按键灵敏'],
      remarksNumDetail: [2600, 6150, 230, 20],
      detail: [
        {
          username: '商务**精英',
          values: 5,
          content: '黑色很低调沉稳，微砂表面一点都不沾指纹，做工非常考究！',
          goods: 'iPhone 6/6s - 曜石黑',
          time: '2025-05-11 15:30'
        }
      ]
    }
  },

  // 1005: 品胜 苹果8/7高透气囊防摔手机壳
  '1005': {
    goodsId: '1005',
    title: '品胜 苹果8/7高透气囊防摔手机壳 四角加厚防撞软硅胶全包保护套',
    price: 19.90,
    goodsImg: ['static/img/goodsList/item-show-5.jpg'],
    tags: ['大牌品胜', '安全防摔', '光学纹理', '持久高透'],
    discount: ['满40减6', '满80减15'],
    promotion: ['品牌特惠', '假一赔十'],
    remarksNum: 5420,
    shopName: '品胜数码官方旗舰店',
    setMeal: [
      [
        { intro: 'iPhone 7/8通用 - 透明防摔款', price: 19.90 },
        { intro: 'iPhone 7P/8P通用 - 透明防摔款', price: 21.90 },
        { intro: 'iPhone 7/8通用 - 透黑气囊款', price: 19.90 }
      ]
    ],
    hot: [],
    goodsDetail: [],
    param: [
      { title: '商品名称', content: '品胜气囊加厚防摔软壳' },
      { title: '品牌', content: '品胜 (PISEN)' }
    ],
    remarks: {
      goodAnalyse: 97,
      remarksTags: ['大品牌信得过', '四角气囊厚实', '透光度好'],
      remarksNumDetail: [1400, 3850, 150, 20],
      detail: [
        {
          username: '老**客',
          values: 5,
          content: '一直买品胜的东西，质量很稳定。四角突出的气囊能有效减震！',
          goods: 'iPhone 7/8通用 - 透明防摔款',
          time: '2025-05-13 17:05'
        }
      ]
    }
  },

  // 1006: 图拉斯 苹果XR/11极简超薄微砂硬壳
  '1006': {
    goodsId: '1006',
    title: '图拉斯 苹果XR/11极简超薄微砂硬壳 散热防指纹保护壳',
    price: 38.00,
    goodsImg: ['static/img/goodsList/item-show-6.jpg'],
    tags: ['极致轻薄', '微砂手感', '散热无阻', '官方质保'],
    discount: ['满80减15', '满150减35'],
    promotion: ['满件立减', '赠运费险'],
    remarksNum: 4820,
    shopName: '图拉斯自营旗舰店',
    setMeal: [
      [
        { intro: 'iPhone XR - 极简哑光黑', price: 38.00 },
        { intro: 'iPhone 11 - 极简哑光黑', price: 39.90 },
        { intro: 'iPhone XR - 暗夜蓝', price: 38.00 }
      ]
    ],
    hot: [],
    goodsDetail: [],
    param: [
      { title: '商品名称', content: '图拉斯超薄微砂壳' },
      { title: '重量', content: '仅约15g' }
    ],
    remarks: {
      goodAnalyse: 98,
      remarksTags: ['极轻极薄', '完全不发烫', '裸机手感'],
      remarksNumDetail: [1200, 3480, 120, 20],
      detail: [
        {
          username: '极客**玩',
          values: 5,
          content: '图拉斯的手感真的一绝，微砂质感很高级。',
          goods: 'iPhone XR - 极简哑光黑',
          time: '2025-05-15 13:40'
        }
      ]
    }
  },

  // 1007: 绿联 苹果全包镜头轻薄透明软壳
  '1007': {
    goodsId: '1007',
    title: '绿联 苹果全包镜头轻薄透明软壳 适用iPhone8/7/6s 镜头加高防刮花',
    price: 16.80,
    goodsImg: ['static/img/goodsList/item-show-7.jpg'],
    tags: ['镜头全包', '绿联质造', '高清通透', '抗氧化不易黄'],
    discount: ['满35减5', '满70减12'],
    promotion: ['限时特卖', '官方正品'],
    remarksNum: 3660,
    shopName: '绿联数码官方专营店',
    setMeal: [
      [
        { intro: '4.7英寸 - 高清镜头全包款', price: 16.80 },
        { intro: '5.5英寸 - 高清镜头全包款', price: 18.80 }
      ]
    ],
    hot: [],
    goodsDetail: [],
    param: [
      { title: '商品名称', content: '绿联镜头精孔全包透明壳' },
      { title: '品牌', content: 'UGREEN 绿联' }
    ],
    remarks: {
      goodAnalyse: 97,
      remarksTags: ['镜头保护好', '孔位精准'],
      remarksNumDetail: [950, 2600, 90, 20],
      detail: [
        {
          username: '数码**达人',
          values: 5,
          content: '专门挑带镜头微孔保护的，绿联这个做得很精准！',
          goods: '4.7英寸 - 高清镜头全包款',
          time: '2025-05-14 20:10'
        }
      ]
    }
  },

  // 1008: 倍思 苹果电镀边框超薄透明防摔保护壳
  '1008': {
    goodsId: '1008',
    title: '倍思 苹果电镀边框超薄透明防摔保护壳 裸机手感电镀金/银 适用iPhone系列',
    price: 25.50,
    goodsImg: ['static/img/goodsList/item-show-8.jpg'],
    tags: ['电镀靓丽', '裸机视感', '背部通透', '抗冲击软边'],
    discount: ['满50减8', '满100减18'],
    promotion: ['满2件享9折', '官方授权'],
    remarksNum: 4120,
    shopName: '倍思数码旗舰店',
    setMeal: [
      [
        { intro: 'iPhone 7/8 - 电镀亮银', price: 25.50 },
        { intro: 'iPhone 7/8 - 电镀奢金', price: 25.50 },
        { intro: 'iPhone 7P/8P - 电镀亮银', price: 27.50 }
      ]
    ],
    hot: [],
    goodsDetail: [],
    param: [
      { title: '商品名称', content: '倍思电镀边框透明防摔壳' },
      { title: '材质', content: 'TPU电镀边框+高透复合背板' }
    ],
    remarks: {
      goodAnalyse: 98,
      remarksTags: ['边框很亮', '外观漂亮', '手感舒适'],
      remarksNumDetail: [1100, 2900, 100, 20],
      detail: [
        {
          username: '颜**控',
          values: 5,
          content: '电镀边框在阳光下特别耀眼，透明背板把手机原色展现得淋漓尽致！',
          goods: 'iPhone 7/8 - 电镀亮银',
          time: '2025-05-16 11:55'
        }
      ]
    }
  },

  // 3001: 维他 柠檬茶
  '3001': {
    goodsId: '3001',
    title: '【赠小风扇】维他 柠檬茶250ml*32盒 礼品装 整箱',
    price: 71.9,
    goodsImg: ['static/img/index/seckill/seckill-item1.jpg'],
    tags: ['整箱特惠', '原汁原味', '真茶真柠檬', '破损包赔'],
    discount: ['满69减10', '满139减25'],
    promotion: ['限时秒杀', '买整箱赠小风扇'],
    remarksNum: 24500,
    shopName: '维他饮料官方旗舰店',
    setMeal: [
      [
        { intro: '原味 250ml*32盒 (经典整箱装)', price: 71.9 },
        { intro: '低糖原味 250ml*32盒 (健康低糖)', price: 73.9 },
        { intro: '锡兰风味 250ml*32盒 (浓郁茶香)', price: 75.9 }
      ],
      [
        { intro: '原味+低糖 双箱特惠装 (共64盒)', price: 139.0 }
      ]
    ],
    hot: [],
    goodsDetail: [],
    param: [
      { title: '商品名称', content: '维他柠檬茶250ml*32盒' },
      { title: '品牌', content: '维他 (Vita)' },
      { title: '规格', content: '250ml*32盒' },
      { title: '产地', content: '中国大陆' },
      { title: '保质期', content: '12个月' },
      { title: '储藏条件', content: '常温避光保存，冷藏口感更佳' }
    ],
    remarks: {
      goodAnalyse: 99,
      remarksTags: ['正品好喝', '夏天必备', '包装结实', '物流极快'],
      remarksNumDetail: [5200, 18500, 600, 50],
      detail: [
        {
          username: '茶**迷',
          values: 5,
          content: '维他柠檬茶的味道无可替代，冰镇之后太爽口了，整箱买非常划算！',
          goods: '原味 250ml*32盒 (经典整箱装)',
          time: '2025-05-18 16:30'
        }
      ]
    }
  },

  // 3002: Kindle Paperwhite
  '3002': {
    goodsId: '3002',
    title: 'Kindle Paperwhite 全新升级版6英寸护眼非反光电子墨水',
    price: 989.0,
    goodsImg: ['static/img/index/seckill/seckill-item2.jpg'],
    tags: ['护眼电子墨水', '超长续航', '正品保障', '全国联保'],
    discount: ['满500减50', '满1000减120'],
    promotion: ['限时特卖', '享分期免息'],
    remarksNum: 8930,
    shopName: '亚马逊电子自营店',
    setMeal: [
      [
        { intro: '8GB 经典黑色 (标准单机版)', price: 989.0 },
        { intro: '8GB 纯净白色 (标准单机版)', price: 989.0 },
        { intro: '32GB 经典黑色 (海量存储版)', price: 1258.0 }
      ],
      [
        { intro: '8GB黑 + 原装皮套保护套装', price: 1088.0 },
        { intro: '8GB白 + 商务真皮套套装', price: 1088.0 }
      ]
    ],
    hot: [],
    goodsDetail: [],
    param: [
      { title: '商品名称', content: 'Kindle Paperwhite 电子书阅读器' },
      { title: '屏幕尺寸', content: '6英寸Carta电子墨水屏' },
      { title: '分辨率', content: '300 ppi' },
      { title: '内置阅读灯', content: '5个LED阅读灯' },
      { title: '防水等级', content: 'IPX8级防水' }
    ],
    remarks: {
      goodAnalyse: 98,
      remarksTags: ['看书神器', '屏幕细腻不刺眼', '续航持久', '手感极好'],
      remarksNumDetail: [2100, 6500, 280, 30],
      detail: [
        {
          username: '书**痴',
          values: 5,
          content: '墨水屏确实不伤眼，字迹非常清晰，像读纸质书一样，阅读必备！',
          goods: '8GB 经典黑色 (标准单机版)',
          time: '2025-05-17 21:05'
        }
      ]
    }
  },

  // 3003: 粮悦 大吃兄糯米锅巴
  '3003': {
    goodsId: '3003',
    title: '粮悦 大吃兄糯米锅巴 安徽特产锅巴糯米原味400g*2盒',
    price: 21.8,
    goodsImg: ['static/img/index/seckill/seckill-item3.jpg'],
    tags: ['徽派地道传统', '手工原粮制作', '酥脆可口', '休闲零食'],
    discount: ['满39减5', '满69减12'],
    promotion: ['第二件半价', '爆款零食热卖'],
    remarksNum: 15300,
    shopName: '大吃兄零食旗舰店',
    setMeal: [
      [
        { intro: '经典原味 400g*2盒', price: 21.8 },
        { intro: '蟹黄风味 400g*2盒', price: 23.8 },
        { intro: '麻辣牛肉味 400g*2盒', price: 22.8 }
      ],
      [
        { intro: '经典原味 400g*4盒 (家庭特惠装)', price: 39.9 },
        { intro: '三味组合 400g*3盒 (原味+蟹黄+麻辣)', price: 32.5 }
      ]
    ],
    hot: [],
    goodsDetail: [], // 无对应图，展示暂无图片
    param: [
      { title: '商品名称', content: '粮悦大吃兄手工糯米锅巴' },
      { title: '品牌', content: '粮悦大吃兄' },
      { title: '产地', content: '安徽省合肥市' },
      { title: '净含量', content: '800g (400g*2盒)' },
      { title: '保质期', content: '9个月' },
      { title: '存储条件', content: '密封避光、阴凉干燥处' }
    ],
    remarks: {
      goodAnalyse: 99,
      remarksTags: ['酥脆掉渣', '香味浓郁', '包装完好', '吃完再来'],
      remarksNumDetail: [3200, 11800, 260, 40],
      detail: [
        {
          username: '零食**控',
          values: 5,
          content: '锅巴特别香脆，粒粒分明，一点都不油腻，已经买过好几次了，强烈推荐！',
          goods: '经典原味 400g*2盒',
          time: '2025-05-19 14:15'
        }
      ]
    }
  },

  // 3004: 清风 抽纸
  '3004': {
    goodsId: '3004',
    title: '【京东超市】清风（APP）抽纸 原木纯品金装系列 3层120抽*24包',
    price: 49.9,
    goodsImg: ['static/img/index/seckill/seckill-item4.jpg'],
    tags: ['原生木浆', '亲肤无刺激', '湿水不易破', '居家必备'],
    discount: ['满59减8', '满99减18'],
    promotion: ['整箱特卖', '品质生活节'],
    remarksNum: 42100,
    shopName: '清风纸业自营旗舰店',
    setMeal: [
      [
        { intro: '原木纯品金装 3层120抽*24包 (经典整箱装)', price: 49.9 },
        { intro: '原木纯品金装 3层100抽*30包 (超值大箱装)', price: 54.9 },
        { intro: '原木纯品超韧 4层90抽*24包 (加厚四层装)', price: 52.9 }
      ]
    ],
    hot: [],
    goodsDetail: [],
    param: [
      { title: '商品名称', content: '清风原木纯品金装抽纸' },
      { title: '主要原料', content: '100%原生木浆' },
      { title: '层数与抽数', content: '3层120抽/包' },
      { title: '包装规格', content: '24包/箱' }
    ],
    remarks: {
      goodAnalyse: 99,
      remarksTags: ['纸张柔软', '吸水性强', '不掉纸屑', '大品牌实惠'],
      remarksNumDetail: [9500, 31800, 720, 80],
      detail: [
        {
          username: '居家**能手',
          values: 5,
          content: '清风的纸质一如既往的好，纸质细腻柔软，湿水也不容易烂，整箱买很划算。',
          goods: '原木纯品金装 3层120抽*24包 (经典整箱装)',
          time: '2025-05-16 09:20'
        }
      ]
    }
  },

  // 3005: NIKE耐克 男子休闲鞋
  '3005': {
    goodsId: '3005',
    title: 'NIKE耐克 男子休闲鞋 AIR MAX 90 ESSENTIAL 气垫经典复古跑鞋',
    price: 559.9,
    goodsImg: ['static/img/index/seckill/seckill-item5.jpg'],
    tags: ['经典气垫', '透气减震', '耐磨抓地', '官方正品'],
    discount: ['满300减30', '满600减70'],
    promotion: ['限时折扣', '正品联保'],
    remarksNum: 7800,
    shopName: 'NIKE官方自营专区',
    setMeal: [
      [
        { intro: '40 码 / 黑白经典配色', price: 559.9 },
        { intro: '41 码 / 黑白经典配色', price: 559.9 },
        { intro: '42 码 / 黑白经典配色', price: 559.9 }
      ],
      [
        { intro: '42.5 码 / 黑白经典配色', price: 559.9 },
        { intro: '43 码 / 黑白经典配色', price: 559.9 },
        { intro: '44 码 / 纯白复古配色', price: 569.9 }
      ]
    ],
    hot: [],
    goodsDetail: [],
    param: [
      { title: '商品名称', content: 'NIKE AIR MAX 90 休闲运动鞋' },
      { title: '鞋面材质', content: '织物 + 皮革拼接' },
      { title: '鞋底功能', content: 'Max Air后跟缓震气垫' },
      { title: '适用场地', content: '公路/硬地/日常休闲' }
    ],
    remarks: {
      goodAnalyse: 98,
      remarksTags: ['正品无误', '脚感舒适', '包裹性好', '颜值超高'],
      remarksNumDetail: [1800, 5800, 180, 20],
      detail: [
        {
          username: '球鞋**玩家',
          values: 5,
          content: 'Air Max 90 经典百搭，后跟气垫缓震脚感很明显，上脚帅气，尺码标准！',
          goods: '42 码 / 黑白经典配色',
          time: '2025-05-15 17:40'
        }
      ]
    }
  }
};

/**
 * 根据 goodsId 获取完整商品详情
 */
export function getGoodsDetailById (goodsId) {
  const idStr = String(goodsId || '');
  if (idStr && detailedGoodsInfoMap[idStr]) {
    return JSON.parse(JSON.stringify(detailedGoodsInfoMap[idStr]));
  }
  // 查找基础商品
  const found = allBasicGoodsList.find(item => String(item.goodsId) === idStr);
  if (found) {
    return buildMockDetailFromBasic(found);
  }
  // 默认返回第一款
  return JSON.parse(JSON.stringify(detailedGoodsInfoMap['1001']));
}



// WEBPACK FOOTER //
// ./src/vuex/goodsData.js